/* Load optional theme components only when their HTML is present. */
(() => {
  const config = document.currentScript;
  if (!config) return;
  const groups = [
    ['parallax', 'parallax-hero'],
    ['stories', 'insta-stories'],
    ['scroll-progress', 'page-scroll-progress'],
    ['date-countdown', 'date-countdown-timer'],
    ['results', 'results-container'],
    ['timeline', 'shrine-timeline,timeline-slider'],
    ['content-tabs', 'content-tabs']
  ].map(([name, selector]) => ({
    name, selector, url: config.getAttribute('data-' + name), attempts: 0, state: 'idle'
  }));

  function load(group) {
    if (!group.url || group.state !== 'idle' || group.attempts >= 2) return;
    group.state = 'loading';
    group.attempts++;
    const script = document.createElement('script');
    script.src = group.url;
    script.async = true;
    script.onload = () => { group.state = 'loaded'; };
    script.onerror = () => {
      script.remove();
      group.state = 'idle';
      if (group.attempts < 2) setTimeout(() => load(group), 1000);
      else console.warn('Theme feature could not load:', group.name);
    };
    document.head.appendChild(script);
  }

  function scan(root) {
    if (!root || !root.querySelector) return;
    groups.forEach(group => {
      if (group.state === 'idle' &&
          (root.matches?.(group.selector) || root.querySelector(group.selector))) load(group);
    });
  }

  // Observe additions so editor updates and AJAX sections work as well as initial HTML.
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
    if (groups.every(group => group.state === 'loaded')) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  scan(document);
})();
